// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loaders_loaderContainer__7MXMQ","webyLoaderBox":"Loaders_webyLoaderBox__-aPdf","webyLoader":"Loaders_webyLoader__5RLnX"};